export interface BffResponseEnvelope<T = unknown> {
  code: number | string;
  msg: string;
  data: T;
}

export const isBffResponseEnvelope = (value: unknown): value is BffResponseEnvelope => {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Record<string, unknown>;
  return (
    (typeof candidate.code === 'number' || typeof candidate.code === 'string') &&
    typeof candidate.msg === 'string' &&
    Object.prototype.hasOwnProperty.call(candidate, 'data')
  );
};

export const unwrapBffResponse = <T = unknown>(value: T | BffResponseEnvelope<T>): T =>
  isBffResponseEnvelope(value) ? value.data : (value as T);

export const getResponseMessage = (responseData: any): string => {
  if (!responseData) return '';
  if (Array.isArray(responseData.message)) return responseData.message.join(', ');
  return (
    responseData.msg ||
    responseData.message ||
    responseData.errorMessage ||
    responseData.error ||
    ''
  );
};
